import {createSlice } from '@reduxjs/toolkit'

const ArticleSlice = createSlice({
    name: "ArticleSlice",
    initialState: {
        Article: {
            Income: [],
            Expenditure: [],
            Collection: []
        }
    },
    reducers: {
       AddArticle(state, actions) {
        state.Article.Income = []
        state.Article.Expenditure = []
        state.Article.Collection = []
        const SortData = actions.payload.sort((a , b) => {
            return a.Name > b.Name ? 1 : -1            
        })
        SortData.map((el) => {
            switch(el.Type){
                case('income'):{
                    state.Article.Income.push(el)
                    break;
                }
                case('expenditure'):{
                    state.Article.Expenditure.push(el)
                    break;
                }
                case('collection'):{
                    state.Article.Collection.push(el)
                    break;
                }
                default:{
                    break;
                }
            }
            return(el)
        })
       }
    }
})

export default ArticleSlice.reducer
export const { AddArticle } = ArticleSlice.actions